import axios from "axios";
import {getAccessToken} from "../../bridge/access-token";

export default class ApiGateway {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.axiosClient = axios.create({
            baseURL: baseUrl,
        });
        this.onRequestError = this.onRequestError.bind(this);
        this.onBeforeRequest = this.onBeforeRequest.bind(this);
        this.onResponseSuccess = this.onResponseSuccess.bind(this);
        this.onResponseError = this.onResponseError.bind(this);

        this.axiosClient.interceptors.request.use(this.onBeforeRequest, this.onRequestError);
        this.axiosClient.interceptors.response.use(this.onResponseSuccess, this.onResponseError);
    }

    async onBeforeRequest(config) {
        config.headers = config.headers || {};
        config.headers["x-amz-access-token"] = await getAccessToken();
        return config;
    }

    onResponseSuccess(response) {
        return response;
    };

    onResponseError(error) {
        // debugger;
        try{
            const message = error.response.data.message;
            const errorMessage = JSON.parse(message);
            console.log("error response", errorMessage);
            throw new Error(errorMessage.errorCode);
        } catch (e) {
            // return a app wide generic error
            throw e;
        }
        // TODO handle 401
    }

    onRequestError(error) {
        throw error;
    };
}



// WEBPACK FOOTER //
// ./src/network/base/api-gateway.js